export default {
  delete: 'Удалить',
  makePublic: 'Сделать публичным',
  makePrivate: 'Сделать приватным',
  save: 'Сохранить',
  saved: 'Элемент пользовательского интерфейса сохранён',
  addField: 'Добавить поле',
  addFilter: 'Добавить фильтер',
  addButton: 'Добавить кнопку',
  fields: 'Поля',
  filters: 'Фильтры',
  buttons: 'Кнопки',
  field: 'Поле',
  filter: 'Фильтер',
  button: 'Кнопка'
}
